<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        header="Perfil"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-4"
        modal >
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="descricao" v-model="form.descricao" class="w-full" />
                        <label for="descricao">Descrição<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['descricao'] }}</div>
                </div>
                <div v-if="mostrarAdministrador" class="field mt-1">
                    <div class="flex align-items-center gap-2">
                        <Checkbox inputId="administrador" v-model="form.administrador" binary
                            :disabled="administradorTravado" aria-describedby="administrador-ajuda" />
                        <label for="administrador">Administrador</label>
                    </div>
                    <small id="administrador-ajuda" class="block text-xs text-gray-600 mt-1">
                        {{ administradorTravado
                            ? 'Você não tem permissão para remover administrador. Procure o suporte.'
                            : 'Administrador tem acesso total ao sistema, independente das permissões marcadas.' }}
                    </small>
                    <div class="text-xs text-red-500">{{ errors['administrador'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button
                    type="submit"
                    label="Salvar"
                    severity="success"
                    icon="pi pi-save"
                    size="small"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
                <Button
                    label="Fechar"
                    severity="warn"
                    icon="pi pi-times"
                    size="small"
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';

import Perfil from '@/service/perfil.js';

export default {
    components: { Dialog,
                  FloatLabel,
                  Button,
                  InputText,
                  Checkbox,
                },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        podeAdministrar: {
            type: Boolean,
            default: false
        },
        podeRemoverAdministrador: {
            type: Boolean,
            default: false
        },
    },
    emits: ['save','close'],
    computed: {
        // perfil já administrador só desmarca quem tem USUARIO_REMOVER_ADMINISTRADOR (o backend decide o resto: 403/422)
        administradorTravado() {
            return !!this.data.administrador && !this.podeRemoverAdministrador;
        },
        // quem só tem a permissão de remover vê o checkbox apenas em perfil já administrador (nada a marcar nos outros)
        mostrarAdministrador() {
            return this.podeAdministrar || (this.podeRemoverAdministrador && !!this.data.administrador);
        },
    },
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    methods: {
        onShow() {
            this.form = Perfil.parse({...this.data});
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            // Só envia `administrador` se mudou (quem tem só a permissão de remover nunca manda true; evita 403 à toa).
            if(!!form.administrador === !!this.data.administrador) {
                const { administrador, ...semAdministrador } = form;
                form = semAdministrador;
            }
            if(form.id) {
                return Perfil.update(form.id,form);
            }
            return Perfil.create(form);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.$emit('save');
                    this.$emit('close', {perfil:response.data.data, novo:form.id == undefined});
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
